export const PMDD = 
{
    Metadata:{Name:'PMDD',maxColumn:2,numRows:15},
    Sections:
    [
        {
            Headers:[
                "",
                "Yes",
                "No",
            ],
            Questions:[
                {
                    Prompt:"I feel much more depressed, down, tearful, sad or hopeless before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I feel anxious, tense, nervous, “keyed up” or “on edge” before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I feel hypersensitive to rejection, or, My emotions feel very unstable and unpredictable before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I feel much more irritable or I get angry easily before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I have thoughts about suicide or hurting myself before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I experience feelings of hopelessness before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I am much less interested than usual in my hobbies and daily activities before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I find it much harder to concentrate before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I feel much more tired and low in energy before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I tend to crave carbohydrates, feel hungry all the time, or eat more than usual before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I find myself tired, oversleeping or taking naps, or, I'm not sleeping well at night before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I am bothered by breast tenderness or swelling, increased headaches, joint or muscle pain, bloating or water retention, and/or weight gain before the start of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"These symptoms interfere or cause problems in my day-to-day activities and/or relationships.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"Most of my symptoms disappear by the end of my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"I have many of these symptoms the whole month, but they get worse before my period.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
            ]
        },
    ]
}